export var StatisticSourceType;

(function (StatisticSourceType) {
  StatisticSourceType["Quote"] = "quote";
})(StatisticSourceType || (StatisticSourceType = {}));

export var StatisticFromType;

(function (StatisticFromType) {
  StatisticFromType["Email"] = "email";
  StatisticFromType["Cms"] = "cms";
  StatisticFromType["EmailViewed"] = "email_viewed";
})(StatisticFromType || (StatisticFromType = {}));